export default [
  { action: 'beforeDinner', text: 'Before dinner' },
  { action: 'afterDinner', text: 'After dinner' },
  { action: 'party', text: 'Party' },
  { action: 'any', text: 'Any time' },
];
